import { render, staticRenderFns } from "./WorkflowLicense.vue?vue&type=template&id=17b5134d"
import script from "./WorkflowLicense.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowLicense.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports